import React, { useState } from 'react'
import { Team } from 'util/constants'
import TeamAvatarModal from './TeamAvatarModal'
import TeamAboutBriefModal from './TeamAboutBriefModal'
import TeamAboutIssueModal from './TeamAboutIssueModal'
import TeamDisplaynameModal from './TeamDisplaynameModal'
import TeamnameModal from './TeamnameModal'
import TeamAboutLinksModal from './TeamAboutLinksModal'
import TeamAlignmentModal from './TeamAlignmentModal'
import ProfileSettingsButton from 'ui/ProfileSettingsButton'

interface Props {
    team: Team;
}

const TeamSettingsProfile: React.FC<Props> = ({ team }) => {
    const [showDisplaynameModal, setShowDisplaynameModal] = useState<boolean>(false)
    const [showTeamnameModal, setShowTeamnameModal] = useState<boolean>(false)
    const [showAvatarModal, setShowAvatarModal] = useState<boolean>(false)
    const [showBriefModal, setShowBriefModal] = useState<boolean>(false)
    const [showLinksModal, setShowLinksModal] = useState<boolean>(false)
    const [showIssueModal, setShowIssueModal] = useState<boolean>(false)
    const [showAlignmentModal, setShowAlignmentModal] = useState<boolean>(false)

    return (
        <div className="p-2">
            {/* General Section */}
            <div className="form-control space-y-2">
                <label className="form-label text-base">General</label>
                <ProfileSettingsButton
                    title="Partea name"
                    description="Set your partea's unique name."
                    onClick={() => setShowTeamnameModal(true)}
                />
                <ProfileSettingsButton
                    title="Name"
                    description="Set your partea's display name."
                    onClick={() => setShowDisplaynameModal(true)}
                />
                <ProfileSettingsButton
                    title="Avatar"
                    description="Add or change your partea's profile avatar."
                    onClick={() => setShowAvatarModal(true)}
                />
            </div>

            {/* About Section */}
            <div className="form-control space-y-2">
                <label className="form-label text-base">About</label>
                <ProfileSettingsButton
                    title="Brief"
                    description="Add a short bio to your partea's profile."
                    onClick={() => setShowBriefModal(true)}
                />
                <ProfileSettingsButton
                    title="#1 Issue"
                    description="Share what matters most to your partea."
                    onClick={() => setShowIssueModal(true)}
                />
                <ProfileSettingsButton
                    title="Perspective"
                    description="Define your partea's social and political views."
                    onClick={() => setShowAlignmentModal(true)}
                />
                <ProfileSettingsButton
                    title="Links"
                    description="Add social media and other links."
                    onClick={() => setShowLinksModal(true)}
                    settingValue={team.about?.bio_links?.value?.length || 0}
                />
            </div>

            {/* Modals */}
            {showTeamnameModal && (
                <TeamnameModal 
                    team={team}
                    onClose={() => setShowTeamnameModal(false)} 
                />
            )}
            {showDisplaynameModal && (
                <TeamDisplaynameModal 
                    team={team}
                    onClose={() => setShowDisplaynameModal(false)} 
                />
            )}

            {showAvatarModal && (
                <TeamAvatarModal 
                    team={team}
                    onClose={() => setShowAvatarModal(false)} 
                />
            )}

            {showBriefModal && (
                <TeamAboutBriefModal 
                    team={team}
                    onClose={() => setShowBriefModal(false)} 
                />
            )}

            {showLinksModal && (
                <TeamAboutLinksModal 
                    team={team}
                    onClose={() => setShowLinksModal(false)} 
                />
            )}

            {showIssueModal && (
                <TeamAboutIssueModal 
                    team={team}
                    onClose={() => setShowIssueModal(false)} 
                />
            )}
            {showAlignmentModal && (
                <TeamAlignmentModal 
                    team={team}
                    onClose={() => setShowAlignmentModal(false)} 
                />
            )}
        </div>
    )
}

export default TeamSettingsProfile 